import * as station from '../actions/stationQueryAction'

const initialState = {
//    stationId: undefined,
//    record: { devices: [], inverters: []},
//    error: undefined,
//    status: 0
};

const stationRecord = (state = initialState, action) => {
    switch (action.type) {
        case station.STATION_RECORD_REQUEST:
            let station_state = {
                    stationId: action.stationId,
                    record: { devices: [], inverters: []},
                    error: undefined,
                    status: 1
                }

            if (state[action.stationId]) {
                station_state = {
                    ...state[action.stationId],
                        error: undefined,
                   status: 1
                }
            }
            
            return { ...state, [action.stationId]: station_state };

        case station.STATION_RECORD_SUCCESS:
            let new_state = {
                stationId: action.stationId,
                record: action.record,
                error: undefined,
                status: 2
            }
            return { ...state, [action.stationId]: new_state };

        case station.STATION_RECORD_FAILURE:
            let failure_state = {
                ...state[action.stationId],
                error: action.error,
                status: 3
            }
            return { ...state, [action.stationId]: failure_state };
        default:
            return (state);
    };
}

export default stationRecord;
